module.exports = __webpack_public_path__ + "img/sv1.a898bd01.svg";